const cartIcon = document.getElementById("cart-icon");
if (cartIcon) {
  cartIcon.setAttribute("role", "button");
  cartIcon.setAttribute("aria-haspopup", "dialog");

  const cartDrawLoaderListener = (evt) => {
    cartIcon.classList.add("spin");
    evt.preventDefault();

    if (document.querySelector("cart-drawer-discounts")) {

    }

    // defined in global-titus-revive.js
    window.theme.loader.cartLoader().then(async () => {
      if (
        customElements.get("cart-drawer") &&
        document.getElementsByTagName("cart-drawer").length > 0
      ) {
        var cartDrawer = document.getElementsByTagName("cart-drawer")[0];

        // load scripts that would otherwise be loaded by the product-form component through the renderContents function
        if (!cartDrawer.scriptsLoaded) {
          if (!document.querySelector(`script[src="${theme.scripts.cartItems}"]`)) {
            await window.loadScript(theme.scripts.cartItems);
          }
  
          if (!document.querySelector(`script[src="${theme.scripts.shippingCalculator}"]`) && cartDrawer.dataset.shippingCalculator) {
            await window.loadScript(theme.scripts.countryProvinceSelector);
            await window.loadScript(theme.scripts.shippingCalculator);
          }
  
          cartDrawer.scriptsLoaded = true;
        }

        // open the drawer
        cartDrawer.open();
      }
    }).catch(() => {
      // case on of both script fails to load, just open the a href cart
      cartIcon.removeEventListener("click", cartDrawLoaderListener);
      cartIcon.removeEventListener("keydown", cartDrawLoaderKeyListener);
      cartIcon.dispatchEvent(new MouseEvent('click'));
    }).finally(() => {
      cartIcon.classList.remove("spin");
    });

    cartIcon.removeEventListener("click", cartDrawLoaderListener);
    cartIcon.removeEventListener("keydown", cartDrawLoaderKeyListener);
  };

  const cartDrawLoaderKeyListener = (evt) => {
    if (evt.key !== " ") return;
    cartDrawLoaderListener(evt);
  };

  cartIcon.addEventListener("click", cartDrawLoaderListener);
  document.addEventListener("wk:wishlist:add-to-cart:success", cartDrawLoaderListener);

  cartIcon.addEventListener("keydown", cartDrawLoaderKeyListener);
}
